import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center text-dark fw-bolder my-1 fs-3"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_6 = {
  key: 2,
  class: "card"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "card-body pt-0"
}
const _hoisted_9 = { class: "text-gray-800" }
const _hoisted_10 = { class: "badge badge-light" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.$route.path.includes('profile'))
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, " Subscriptions "))
          : _createCommentVNode("", true),
        _hoisted_5,
        (_ctx.loadingSubscriptions)
          ? (_openBlock(), _createBlock(_component_Spinner, { key: 1 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              (_ctx.tableData.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(), _createBlock(_component_Datatable, {
                      "table-data": _ctx.tableData,
                      "table-header": _ctx.tableHeader,
                      "enable-items-per-page-dropdown": false,
                      key: _ctx.tableKey
                    }, _createSlots({
                      "cell-user": _withCtx(({ row: subscription }) => [
                        _createElementVNode("small", null, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(subscription.company), 1)
                        ])
                      ]),
                      "cell-status_display": _withCtx(({ row: subscription }) => [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", [
                    subscription.status == _ctx.SubscriptionStatus.ACTIVE
                      ? 'badge-light-success'
                      : subscription.status == _ctx.SubscriptionStatus.PENDING
                      ? 'badge-light'
                      : 'badge-light-danger',
                  ]])
                        }, _toDisplayString(subscription.status_display), 3)
                      ]),
                      "cell-autorenew": _withCtx(({ row: subscription }) => [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(subscription.autorenew ? "Autorenew-debit" : "No Autorenew"), 1)
                      ]),
                      "cell-plan": _withCtx(({ row: subscription }) => [
                        _createElementVNode("small", null, _toDisplayString(subscription.plan_verbose.name), 1)
                      ]),
                      "cell-created": _withCtx(({ row: subscription }) => [
                        _createElementVNode("small", null, _toDisplayString(_ctx.$filters.formatDate(subscription.created)), 1)
                      ]),
                      "cell-use": _withCtx(({ row: subscription }) => [
                        _createElementVNode("small", null, _toDisplayString(subscription.count_used) + " / " + _toDisplayString(subscription.limit), 1)
                      ]),
                      _: 2
                    }, [
                      (!_ctx.isAdmin)
                        ? {
                            name: "cell-edit",
                            fn: _withCtx(({ row: subscription }) => [
                              _createVNode(_component_el_select, {
                                placeholder: "Action",
                                size: "small",
                                loading: _ctx.updating === subscription.id
                              }, {
                                default: _withCtx(() => [
                                  (
                      subscription.status === _ctx.SubscriptionStatus.EXPIRED &&
                      subscription.card
                    )
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 0,
                                        label: "Renew",
                                        onClick: ($event: any) => (_ctx.renew(subscription))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (subscription.card)
                                    ? (_openBlock(), _createBlock(_component_el_option, {
                                        key: 1,
                                        label: 
                      subscription.autorenew
                        ? 'Detach autorenewal'
                        : 'Autorenew on expiry'
                    ,
                                        onClick: ($event: any) => (_ctx.toggleAutoRenew(subscription))
                                      }, null, 8, ["label", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["loading"])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["table-data", "table-header"]))
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ]))
}